import { CallRecordKey } from 'flow/types/EntityKeys';
import SectionContact from '../../misc/contact/SectionContact';

interface Props {
    callRecordKey: CallRecordKey;
}

const ContactTabContent = ({ callRecordKey }: Props) => (
    <div className="pb-8">
        <SectionContact callRecordKey={callRecordKey} />
    </div>
);

export default ContactTabContent;
